define(['appcontext'], (appContext) => ({
    getErrors (response) {
        try {
            return JSON.parse(response.responseText || '{}').errors || {};
        } catch (err) {
            return {};
        }
    },

    responseFromErrors (errors) {
        return {responseText: JSON.stringify({errors})};
    },

    showAPIErrorMessage (alert, response) {
        if (!response.status || response.status < 500) {
            this.showCorrectErrorMessage(alert, this.getErrors(response));
        }
    },

    showCorrectErrorMessage (alert, errors) {
        const message = _.wrapArray(errors.message || []);
        const text = _.isEmpty(message) ? appContext.tr('Please, correct errors') : _.wrapArray(message).
            join('\n');
        const title = errors?.title;

        this.showErrorAlert(alert, text, title);
    },

    showErrorAlert (alert, text, title) {
        alert.error({
            title: title || appContext.tr('Error'),
            text
        });
    }
}));
